
import { PackageData } from "@/pages/CreatePackage";
import { getDefaultSettingsForTemplate } from "./pdf-templates/constants";
import { templateGenerators } from "./pdf-templates";

export const generatePackagePDF = async (packageData: PackageData, templateId: string): Promise<void> => {
  const settingsStr = localStorage.getItem('pdfTemplateSettings');
  const allSettings = settingsStr ? JSON.parse(settingsStr) : null;
  const templateSettings = allSettings?.[templateId] || getDefaultSettingsForTemplate(templateId);
  
  const generator = templateGenerators[templateId as keyof typeof templateGenerators] || templateGenerators.template1;
  const htmlContent = await generator(packageData, templateSettings);
  
  const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  
  const newWindow = window.open(url, '_blank');
  if (newWindow) {
    newWindow.onload = () => {
      setTimeout(() => {
        try {
          newWindow.print();
        } catch (e) {
          console.error("Printing failed:", e);
          newWindow.close();
        }
      }, 500);
    };
  } else {
      alert('Please allow pop-ups for this website to print the PDF.');
  }
  
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 2000);
};
